import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Link, type GeneralLinkProps } from './link';
export const TextLink = t0 => {
  const $ = _c(10);
  let T0;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      className,
      ...t3
    } = t0;
    props = t3;
    T0 = Link;
    t1 = props;
    t2 = classNames("underline", {
      "text-(--mui-palette-text-disabled)": props.disabled,
      "text-(--mui-palette-text-primary) hover:text-(--mui-palette-text-secondary)": !props.disabled
    }, className);
    $[0] = t0;
    $[1] = T0;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    T0 = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== T0 || $[6] !== props.children || $[7] !== t1 || $[8] !== t2) {
    t3 = <T0 {...t1} className={t2}>{props.children}</T0>;
    $[5] = T0;
    $[6] = props.children;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};